import { SHOP_PRODUCTS_PATH } from '@constant'
import { isUltimate } from '@merchant-backend/util'
import { Modal } from 'hljd'
import { hashHistory } from 'react-router'
import JoinGroupStore from './JoinGroupModal/store'

class Store {
  constructor() {
    this.joinGroupStore = new JoinGroupStore()
  }

  createGroup = () => {
    if (!isUltimate()) {
      this.notProConfirm('未开通商家服务（付费），无法创建团队')
      return
    }

    hashHistory.push('/localMerchant/siyiGroup')
  }

  joinGroup = () => {
    if (!isUltimate()) {
      this.notProConfirm('未开通商家服务（付费），无法加入团队')
      return
    }

    this.joinGroupStore.openModal()
  }

  notProConfirm = title => {
    Modal.confirm({
      title,
      okText: '开通商家服务',
      cancelText: '遗憾离开',
      onOk: () => {
        hashHistory.push(SHOP_PRODUCTS_PATH)
      }
    })
  }
}

export default Store
